export const boardAccountabilityTour = {
  key: "boardAccountability",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-accountability-toggle"]',
      content: t("Tour_BoardAccountability_Toggle"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-accountability-ai-toggle"]',
      content: t("Tour_BoardAccountability_AiToggle"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-accountability-ai-sub"]',
      content: t("Tour_BoardAccountability_AiSub"),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-accountability-report"]',
      content: t("Tour_BoardAccountability_Report"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-accountability-analysis"]',
      content: t("Tour_BoardAccountability_Analysis"),
      placement: "top",
    },
  ],
};
